import { socketActionType } from "../../../enums/socketEnums";
import styles from "./UtilityBar.module.scss";

export const utilitBarConstants = {
  SEARCH_PLACEHOLDER: "Search...",
  DATE_PLACEHOLDER: ["mm/dd/yyyy", "mm/dd/yyyy"],
  SEARCH_ICON_ALT: "Click to search",
  LIST_ICON_ALT: "List View",
  KANBAN_ICON_ALT: "Tile View",
  CALENDAR_ALT: "calendar",
  DOWNLOAD_TILE: "Download",
  EXPORT_TITLE: "Export",
  MODAL_WIDTH: "50rem",
  BULK_SYNC_UPDATE_TITLE: "Quickbooks Status Confirmation",
  EXPORT_SUCCESS: "Invoice and Bill information have been exported",
  getDownloadSuccess: (count?: number) => (
    <div>
      <span className={styles.countHighlight}>{count}</span>
      {"invoice(s) are being downloaded in the background"}
    </div>
  ),
  BULK_SYNC_STATUS_CONTENT:
    "Confirm you have synced with QBO and change Status to Synced for All Processed Invoices?",
  BULK_SYNC_FAILURE_MESSAGE: "Failed to change status",
  BUTTONS: {
    FILTER_LABEL: "Filter",
    DOWNLOAD_LABEL: "Download Invoice",
    EXPORT_LABEL: "Export to Quickbooks",
    CONFIRM_LABEL: "Confirm",
  },
  INFO_ICON_ALT: "Click to view progress",
};

export const DOWNLOAD_OPTION_VALUES = {
  CARRIER_INVOICE_PDF: "carrierInvoicePDF",
  TRUCK_INVOICE_PDF: "truckInvoicePDF",
  TRUCK_INVOICE_EXCEL: "truckInvoiceExcel",
};

export const DOWNLOAD_OPTIONS = [
  {
    label: "Customer Invoice - PDF",
    value: DOWNLOAD_OPTION_VALUES.CARRIER_INVOICE_PDF,
  },
  {
    label: "Truck Invoice - PDF",
    value: DOWNLOAD_OPTION_VALUES.TRUCK_INVOICE_PDF,
  },
  {
    label: "Truck Invoice - Excel",
    value: DOWNLOAD_OPTION_VALUES.TRUCK_INVOICE_EXCEL,
  },
];

export const DOWNLOAD_FORMATS = {
  EXCEL: "excel",
};

export const fieldNames = {
  DATE_RANGE: "dateRange",
  SEARCH_NAME: "searchField",
};

export const ButtonGroupStyles = {
  color: "#586370",
  backgroundColor: "white",
  border: "1px solid transparent",
  paddingInline: "0.375rem",
  lineHeight: "22px",
};

export const getConfirmMessage = (
  selectedNumber: string,
  actionType: socketActionType,
) => {
  switch (actionType) {
    case socketActionType.EXPORT_TO_QUICKBOOKS:
      return (
        <>
          {`Are you sure you want to export`}
          <span className={styles.countHighlight}>{selectedNumber}</span>
          {`Invoice(s) & Bill(s)?`}
        </>
      );
    case socketActionType.DOWNLOAD_INVOICE:
      return (
        <>
          {"Are you sure you want to download"}
          <span className={styles.countHighlight}>{selectedNumber}</span>
          {"Invoice(s)?"}
        </>
      );
  }
};

export const getWarningMessage = (nonSyncCount: number) => {
  return (
    <>
      {`Warning: there are`}
      <span className={styles.countHighlight}>{nonSyncCount}</span>
      {`files that have not yet been synced with QuickBooks. Do you wish to proceed ?`}
    </>
  );
};

export const FILTER_FIELD_NAMES_TO_COUNT = [
  "invoiceId",
  "companyId",
  "jobId",
  "orderId",
  "invoiceStatus",
  "syncStatus",
] as const;
